import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Product, Accommodation } from '@uc/web/shared/data-models';
import { Observable } from 'rxjs';
import { fetchAccommodationsList } from './data-access/+state/accommodation.actions';
import { getStateAccommodations } from './data-access/+state/accommodation.selectors';
import { AsyncPipe } from '@angular/common';
import { AccommodationCardComponent } from './components/accommodation-card/accommodation-card.component';
import { AccommodationCarouselComponent } from './components/accommodation-carousel/accommodation-carousel.component';
import { NoAccommodationComponent } from './components/no-accommodation/no-accommodation.component';

@Component({
	selector: 'uc-university-accommodation',
	templateUrl: './university-accommodation.component.html',
	imports: [
		AsyncPipe,
		AccommodationCardComponent,
		AccommodationCarouselComponent,
		NoAccommodationComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityAccommodationComponent implements OnInit {
	universityUrl = input<string>('');
	uniId = input<number | null>(null);
	uniName = input<string>('');
	universityExternalUrl = input<string>('');
	ugSearchOrderPosition = input.required<number | null>();
	product = input<Product | null>(null);
	accommodation$!: Observable<Accommodation | null>;

	constructor(private _store: Store) {}

	ngOnInit(): void {
		this._store.dispatch(
			fetchAccommodationsList({
				universityUrl: this.universityUrl(),
			}),
		);

		this.accommodation$ = this._store.select(getStateAccommodations);
	}
}
